export default __webpack_public_path__ + "static/media/CHAMBER_OF_COMMERCE.d4c34d83.png";